import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Col, Row } from "antd";
import { getUser, getUsers } from "../Application/Users.business";
import Searcher from "../UI/Searcher";
import UsersForm from "../UI/Users.form";
import UsersBlockchain from "../UI/UsersBlockchain";

export default function Users() {
  const { id } = useParams();

  useEffect(() => {
    getUsers({
      filter: { access_level: ["partner"] },
      page: 0,
      limit: 10,
      field_sort: "date",
      sort: "descending",
    });
    if (id) {
      getUser(id);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Searcher userId={id} />

      <Row gutter={10} style={{ marginTop: 20 }}>
        <Col xs={24} xl={12} span={12}>
          <UsersForm userId={id} getUser={getUser} />
        </Col>
        <Col xs={24} xl={12} span={12}>
          <UsersBlockchain userId={id} getUser={getUser} getUsers={getUsers} />
        </Col>
      </Row>
    </>
  );
}
